import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface VideoHelpModalProps {
  show: boolean;
  onHide: () => void;
  videoUrl: string;
  title: string;
}

const VideoHelpModal: React.FC<VideoHelpModalProps> = ({
  show,
  onHide,
  videoUrl,
  title,
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={onHide} size="lg" centered className="video-help-modal">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0 bg-dark overflow-hidden rounded-bottom">
        <video
          controls
          autoPlay
          className="w-100"
          style={{ maxHeight: "80vh", display: "block" }}
        >
          <source src={videoUrl} type="video/mp4" />
          <div className="text-white p-4 text-center">
            <p>{t("common.video_not_supported", "Your browser does not support the video tag.")}</p>
            <a href={videoUrl} className="btn btn-primary btn-sm" download>
              {t("common.download_video", "Download Video to Watch")}
            </a>
          </div>
        </video>
      </Modal.Body>
    </Modal>
  );
};

export default VideoHelpModal;

